// export const BASE_API_URL = 'https://edunix-registration-api.beetronix.com';
// export const BASE_API_URL = 'https://mirror-registration-api.beetronix.com';
// export const BASE_API_URL = 'http://localhost:26389';
// export const BASE_API_URL = 'http://beeserver:89';

/* Nukbeh */
// export const BASE_API_URL = 'https://registration-api.alnukhbeh-edu.com';

/* Al Awal */
export const BASE_API_URL = 'https://registration-api.alawalschool.edunixsystem.com';

export const EDUNIX_API = {
	/* TEST */
	/* baseURL: 'https://edunix-api.beetronix.com',
	username: 'admin',
	password: 'a', */

	/* Nukbeh */
	/* baseURL: 'https://api.alnukhbeh-edu.com',
	username: 'dr.fadi',
	password: 'helloAdmin', */

	/* Al Awal */
	baseURL: 'https://api.alnukhbeh-edu.com',
	username: 'admin',
	password: 'a',
}
export const VERSION = '3.9.3';